// import Vue from '../../libs/vue/vue.common'
import api from './api'
import dateformat from './dateformat'

const holidaysSection = {
	name: 'holidays-section',
	delimiters: ['${', '}'],
	template: '#v-holidays-section',
	props: ['date', 'institutions', 'services'],
	data () {
		return {
			opened: false
		}
	},
	methods: {
		getServiceName (id) {
			return this.services ? this.services[id].service_name : ''
		},
		open () {
			this.opened = true
		},
		close () {
			this.opened = false
		},
		toggle () {
			this.opened = !this.opened
		}
	}
}

export default function instSearch () {

	const myapp = new Vue({
		delimiters: ['${', '}'],
		el: '#v-holidays',
		components: {holidaysSection},
		data () {
			return {
				institutions: null,
				services: null,
			}
		},
		computed: {
			/*
				日にちごとの配列に分ける
				[
					{date: '2017年6月17日（土）', institutions: [institution, ...]},
					{date: '2017年6月18日（日）', institutions: [institution, ...]},
					...
				]
			*/
			dateInstitutions () {
				if (!this.institutions || this.institutions.length === 0) {
					return
				}
				const dates = []
				const institutions = {}
				this.institutions.forEach(institution => {
					let date = institution.date
					if (!institutions[date]) {
						dates.push(date)
						institutions[date] = []
					}
					institutions[date].push(institution)
				})
				return dates.sort().map(date => {
					return {
						date: dateformat(date, 'Y年m月d日（W）'),
						institutions: institutions[date]
					}
				})
			},
			isEmpty () {
				return this.institutions && this.institutions.length === 0
			}
		},
		methods: {
			loadInstitutions () {
				const now = Date.now()
				const start = dateformat(now, 'Y-M-D')
				// const end = dateformat(now + 7*4*24*60*60*1000, 'Y-M-D') // 4週間後
				return api.holidays({start}).then(data => {
					this.institutions = data
					return Promise.resolve()
				})
			},
		},
		created () {
			api.institutions.services().then(data => {
				this.services = data
			})
		},
		mounted () {
			this.loadInstitutions().then(() => {
				this.$nextTick(() => {
					if (this.$children[0]) {
						this.$children[0].open()
					}
				})
			})
		}
	})

}